import React, { useEffect, useState, useMemo, useRef, createRef } from 'react';
import { DOMURL, TOKENVALIDATE, errMrssage } from '../../url';
import Button from "@material-ui/core/Button";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import $ from 'jquery'
import OwlCarousel from 'react-owl-carousel';
import Player from '../Player/Player.jsx'
import Loader from '../../component/loader/home_loading';
import { Link } from "react-router-dom";
import VideoPlayer from "../VideoPlayer";
import PopupComponents from '../../component/Popcomponent/popupComponents';
import premiumIcon from '../../assests/images/banner_premium_tag.svg';
import { useHistory, useLocation } from "react-router-dom";
import swal from "sweetalert";

const HomeBanner = (props) => {
  let playLiveStorageValue = localStorage.getItem("playLive");
  let historypush = useHistory();
  const [textWrd, setTxthgt] = useState();
  const [homeBannerlData, sethomeBannerData] = useState([]);
  const [mainTicker, setmainTicker] = useState([]);
  const [isLoading, setisLoading] = useState(true)
  const [showPopup, showPopupSet] = useState(false)
  const [isperaText, setperaText] = useState('')
  const [playLive, setPlayLive] = useState(playLiveStorageValue === "PLAY")
  const [subscriptionCheck, setSubscriptionCheck] = useState("")
  const [state, setState] = useState({
    videoTitle: '',
    entry_id: "",
    aws: [],
    playedDuration: 0,
    videtagmain: "",
    setConfig: false,
    videoUrl: '',
  });
  const userId = localStorage.getItem('userid')
  const location = useLocation();
  useEffect(() => {
    sethomeBannerData(props.data)
    setmainTicker(props.data[0] !== undefined && props.data[0].tiker_data ? props.data[0].tiker_data : '')
    setisLoading(false)
    setSubscriptionCheck(sessionStorage.getItem("user_planstatus"))
    if (location) document.body.classList.remove('overflow-hidden');
  }, [props.data, location, subscriptionCheck]);
  const refsLiveVideo = useRef(null);
  const imgHghtwppr = useRef(null);
  const textHghtwppr = useRef(null);

  // const getTokenValidate = async () => {
  //   await axios.get(TOKENVALIDATE, {
  //     headers: { 'token': localStorage.getItem("token") },
  //   }).then(response => {
  //     if (response.data.status !== "Success") {
  //       swal({
  //         title: "Oops!",
  //         text: errMrssage,
  //         type: "error",
  //         icon: "error",
  //       }).then(function () {
  //         localStorage.clear();
  //         sessionStorage.clear();
  //         window.location.href = "/login"
  //       });
  //     }
  //   })
  // }

  const playLiveVideo = async (e) => {
   // alert(e.currentTarget.getAttribute("data-value"))
   let planStatus = e.currentTarget.getAttribute("data-value")
   let isPremiumStatus = e.currentTarget.getAttribute("data-premvalue")

    await axios.get(TOKENVALIDATE, {
      headers: { 'token': localStorage.getItem("token") },
    }).then((response, e) => {
      if (response.data.status !== "Success") {
        swal({
          title: "Oops!",
          text: errMrssage,
          type: "warning",
          icon: "warning",
        }).then(function () {
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = "/login"
        });
      } else {
        document.body.classList.add('overflow-hidden');
        let isAuth = localStorage.getItem('userid')
        if (!isAuth) {
          window.location.href = "/login"
        }
        else if (planStatus === "1" || isPremiumStatus === "0") {
          let video_url = refsLiveVideo.current.value
          setState({ ...state, videoUrl: video_url });
          localStorage.setItem("playLive", "PLAY");
          setPlayLive(true)
        }
        else {
          historypush.push("/subscription-plans")
        }
        props.playliveVideoPopup('true');
        document.querySelector('#header').classList.add('down')
      }
    })
  };
  const stopLiveVideo = (e) => {
    document.body.classList.remove('overflow-hidden');
    localStorage.setItem("playLive", "STOP");
    setPlayLive(false)
    props.playliveVideoPopup('false');
    document.querySelector('#header').classList.remove('down')
  };
  const viewfullDes = (des) => {
    document.body.classList.add('overflow-hidden');
    Boolean(showPopupSet(true))
    setperaText(des)
  }
  const clsPopBtn = () => {
    document.body.classList.remove('overflow-hidden');
    Boolean(showPopupSet(false))
  }
  if (imgHghtwppr.current !== null) {
    let imagebxHght = imgHghtwppr.current
    // let textHght = textHghtwppr.current
    setTimeout(() => {
      let imageHght = imagebxHght.clientHeight
      setTxthgt(imageHght)
    }, 500)
  }

  if (!isLoading) {
    let currentUrl = window.location.pathname
    let TargetUrl = localStorage.getItem('ecpath')
    return (
      <>
        {
          homeBannerlData !== 'null' && homeBannerlData !== 'undefined' && homeBannerlData !== null && homeBannerlData !== undefined && homeBannerlData.length > 0 ?
            <div className="container amma-cntnt-sldr">
              <div className="row">
                {
                  currentUrl === TargetUrl ? <div className="amma-sldr-wppr d-flex align-items-center justify-content-between">
                    {
                      homeBannerlData !== 'null' && homeBannerlData !== 'undefined' && homeBannerlData !== null && homeBannerlData !== undefined && homeBannerlData.length > 0 && homeBannerlData.map((data, key) => {
                        if (data.type === "1") {
                          // alert('equal1')
                          return (
                            <div className="amma-sldr-img" data-value={subscriptionCheck} data-premvalue={data.is_premium} onClick={playLiveVideo}>
                              <input ref={refsLiveVideo} id={`liveid_${key}`} type="hidden" value={data.value} />
                              {data.is_premium === "1" && <img src={premiumIcon} className='premiumTag' alt="live" />}
                              <img
                                className="aaa"
                                src={`${data.url}`}
                                alt="livetv"
                              />
                            </div>
                          )
                        } else {
                          // alert('equal2')
                          return (
                            <div className="amma-sldr-img" data-value={subscriptionCheck} data-premvalue={data.is_premium}>
                              <Link
                                to={`/video/cat/vod/${data.value}`}
                                className={`box`}
                              >
                                <img
                                  src={`${data.url}`}
                                  alt="vod"
                                />
                              </Link>
                            </div>
                          )
                        }
                      })
                    }

                  </div> : <div className="amma-sldr-wppr d-flex align-items-center justify-content-between">
                    {
                      homeBannerlData !== null && homeBannerlData !== undefined && homeBannerlData.length > 0 && homeBannerlData.map((data, key) => {
                        if (data.type === "1") {
                          // alert(' not equal1')
                          return (
                            <>
                              <div className="amma-sldr-img" data-value={subscriptionCheck} data-premvalue={data.is_premium} onClick={playLiveVideo}>
                                <input ref={refsLiveVideo} id={`liveid_${key}`} type="hidden" value={data.value} />
                                {data.is_premium === "1" && <img src={premiumIcon} className='premiumTag' alt="live" />}
                                <img
                                  src={`${data.url}`}
                                  alt="live"
                                  ref={imgHghtwppr}
                                />
                              </div>
                              {homeBannerlData.length > 1 ? '' : <div className="amma-sldr-text-wppr" ref={textHghtwppr}>
                                {
                                  data.description &&
                                  <div className="title">
                                    <>
                                      <p>
                                        {
                                          window.screen.width < 991 ? data.description ? data.description.substr(0, textWrd * 2) : ''
                                            :
                                            data.description ? data.description.substr(0, textWrd * 2.95) : ''
                                        }
                                        {
                                          data.description !== undefined && data.description !== null && data.description.length > textWrd * 2.95 && <span>
                                            ...
                                            <button type="button" className="see-mr-btn" onClick={(e) => viewfullDes(data.description)}>  See More</button>
                                          </span>

                                        }
                                      </p>
                                    </>
                                  </div>
                                }

                              </div>}
                              {/* ------------------(((((((((( About Text  Pop  Design )))))))))) ------------------------ */}

                              {/* <div className="abt-pop-wppr" >
                              <span className="blk-ovrly" onClick={clsPopBtn} ></span>
                              <div class="abt-pop">
                                <button type="button" className="abt-cls-btn" onClick={clsPopBtn}></button>
                                <div className="abt-txt">
                                {
                                  data.description &&
                                  <p> {data.description} </p>
                                }
                                </div>
                              </div>
                            </div> */}
                            </>
                          )
                        } else {
                          // alert('not equal2')
                          return (
                            <>
                              <div className="amma-sldr-img" data-value={subscriptionCheck} data-premvalue={data.is_premium}>
                                {
                                  data.value !== undefined && data.value !== null && data.value !== '' && data.value !== 'null' && data.value !== 'undefined' ? <Link
                                    to={`/video/cat/vod/${data.value}`}
                                    className={`box`}
                                  >
                                    <img
                                      src={data.url}
                                      alt="vod"
                                      ref={imgHghtwppr}
                                    />
                                  </Link> : <div className={`box`}>
                                    <img
                                      src={data.url}
                                      alt="vod"
                                      ref={imgHghtwppr}
                                    />
                                  </div>
                                }
                                {/* <Link
                              to={`/video/cat/vod/${data.value}`}
                              className={`box`}
                            >
                              <img
                                src={data.url}
                                alt="vod"
                                ref={imgHghtwppr}
                              />
                            </Link> */}
                              </div>
                              {
                                homeBannerlData.length > 1 ? <div className="amma-sldr-text-wppr d-none" ref={textHghtwppr}>
                                  {
                                    data.description &&
                                    <p> {data.description ? data.description : ''} </p>
                                  }
                                  {
                                    data.description &&
                                    <div className="see-mr-btn-wppr">
                                    </div>
                                  }
                                </div> : <div className="amma-sldr-text-wppr " ref={textHghtwppr}>
                                  {
                                    data.description &&
                                    <>
                                      <p>
                                        {
                                          window.screen.width < 991 ? data.description ? data.description.substr(0, textWrd * 2) + '...' : ''
                                            :
                                            data.description ? data.description.substr(0, textWrd * 2.95) + '...' : ''
                                        }
                                        {
                                          data.description !== undefined && data.description !== null && data.description.length > textWrd * 2.95 && <button type="button" className="see-mr-btn" onClick={(e) => viewfullDes(data.description)}>  See More</button>

                                        }
                                      </p>
                                    </>
                                  }

                                </div>
                              }
                              {/* ------------------(((((((((( About Text  Pop  Design )))))))))) ------------------------ */}
                              {/* <div className="abt-pop-wppr" >
                              <span className="blk-ovrly" onClick={clsPopBtn} ></span>
                              <div class="abt-pop">
                                <button type="button" className="abt-cls-btn" onClick={clsPopBtn}></button>
                                <div className="abt-txt">
                                {
                                  data.description &&
                                  <p> {data.description} </p>
                                }
                                </div>
                              </div>
                            </div> */}

                            </>
                          )
                        }
                      })
                    }

                  </div>
                }

              </div>
            </div> : ''
        }
        {state.videoUrl && userId && playLive && (
          <div id="myNav" class="overlay vdo-popbx">
            <button class="closebtn" onClick={stopLiveVideo}>
              &times;
            </button>
            {/* <div className='livbtn-wppr'>
              <div className='livrtx'>
                <p>Live</p>
              </div>
              <div className='cuntbx'>
                <span><FontAwesomeIcon icon={faEye} /></span>
                <p> 0k</p>
              </div>
            </div> */}
            <VideoPlayer
              tittle={
                state.videoTitle
                  ? state.videoTitle
                  : ""
              }
              isSocket={props.isSocket}
              entryid={state.entry_id ? state.entry_id : ""}
              tag={state.videtagmain ? state.videtagmain : ""}
              playedDuration={
                state.playedDuration ? state.playedDuration : 0
              }
              ticker={mainTicker}
              domUrl={DOMURL}
              // videoUrl={`https://nmxlive.akamaized.net/hls/live/529965/Live_1/index.m3u8`}
              // videoUrl={`https://dr1zhpsuem5f4.cloudfront.net/master.m3u8`}
              videoUrl={state.videoUrl}
              aws={state.aws !== undefined ? state.aws : []}
              setConfig={state.setConfig}
            />

          </div>
        )}
        <PopupComponents pertext={isperaText} propClass={`abt-pop-wppr  ${Boolean(showPopup) === true ? 'show' : 'hide'}`} hidePopup={clsPopBtn} />
      </>
    );
  } else {
    return (<Loader />)
  }

}
export default HomeBanner;